<template>
  <el-row style="width: 100%;margin-top: 115px;">
    <el-row style="height: calc(100% - 116px);overflow-y: auto;">
      <!--  轮播图  -->
      <el-row style="height: 240px;width: 100%;">
        <el-carousel :interval="4000" trigger="click" arrow="always" height="240px">
          <el-carousel-item v-for="(item, i) in imgList" :key="i">
            <el-row :style="{backgroundImage: 'url(' + item + ')'}" class="top-img-class">
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </el-row>
      <el-row style="width: 94%;margin-left: 3%;margin-top: 20px;">
        <slot>
        </slot>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'IntroducePage',
  props: ['selId', 'params'],
  data() {
    return {
      dataList: [
        { id: 21, name: '公司简介', component: '/short_introduce'},
        { id: 22, name: '企业文化', component: '/culture'},
        { id: 23, name: '资质荣誉', component: '/honor'},
        { id: 24, name: '核心团队', component: '/team'}
      ],
      selMenu: 0,
      imgList: [require('../../assets/img/introduce/introduce.jpg')],
      dict: {'/short_introduce': 0, '/culture': 1, '/honor': 2, '/team': 3}
    }
  },
  created() {
    let ind = this.dict[this.$route.path]
    if (ind > -1) {
      this.selMenu = ind
    }
  },
  methods: {
    clickMenu(i) {
      if (this.selMenu !== i) {
        this.$router.push(this.dataList[i].component)
      }
    }
  }
}
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .menu-class {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #efefef;
    color: #000000;
    cursor: pointer;
  }
  .menu-class-hover {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #00bf86;
    color: #ffffff;
    cursor: pointer;
  }
  .menu-class:hover {
    background-color: #00bf86;
    color: #ffffff;
  }
  .top-img-class {
    width: 100%;
    height: 240px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/introduce/IntroducePage.vue